import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/dto.js';
import { LegacyOrderHook, LegacyOrderHookId } from '../legacy-order-hook.js';
import { OrderSideEffectType } from './order-side-effect-type.js';
import { OrderSideEffect } from './order-side-effect.js';

const DEFAULT_EMAIL_TEMPLATE: string = 'default';

export class SendProductOrderEmailSideEffect extends OrderSideEffect {
  static readonly TYPE_ID: string = '185a29fcfb2d442fbedbf50bc1af59f3';

  public readonly effectType: OrderSideEffectType = OrderSideEffectType.SendProductOrderConfirmationEmail;

  private constructor(
    public readonly eventId: string | null,
    public readonly emailTemplateId: string,
  ) {
    super();
  }

  get $typeId(): string {
    return SendProductOrderEmailSideEffect.TYPE_ID;
  }

  static default({ eventId }: { eventId: string | null }): SendProductOrderEmailSideEffect {
    return new SendProductOrderEmailSideEffect(eventId, DEFAULT_EMAIL_TEMPLATE);
  }

  static create({ eventId, emailTemplateId }: { eventId: string | null, emailTemplateId: string }): SendProductOrderEmailSideEffect {
    return new SendProductOrderEmailSideEffect(eventId, emailTemplateId);
  }

  static fromMap(context: SerializationContext, map: SerializedData): SendProductOrderEmailSideEffect {
    return new SendProductOrderEmailSideEffect(
        MapUtils.getStringOrNull(map, 'eventId'),
        MapUtils.getString(map, 'emailTemplateId'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'effectType': fromEnumAsString(this.effectType),
      'eventId': this.eventId,
      'emailTemplateId': this.emailTemplateId,
    };
  }

  clone(): this {
    return new SendProductOrderEmailSideEffect(
        this.eventId,
        this.emailTemplateId,
    ) as this;
  }

  isSame(other: SendProductOrderEmailSideEffect): boolean {
    if(this === other) {
      return true;
    }

    return other.effectType === this.effectType &&
      other.eventId === this.eventId &&
      other.emailTemplateId === this.emailTemplateId;
  }

  toLegacyOrderHook(): LegacyOrderHook {
    return LegacyOrderHook.create(LegacyOrderHookId.SendProductOrderConfirmationEmail, {
      eventId: this.eventId,
    });
  }

  static verifyType(order: DataModel): boolean {
    return order instanceof SendProductOrderEmailSideEffect;
  }

  static assertType(order: DataModel): order is SendProductOrderEmailSideEffect {
    return order instanceof SendProductOrderEmailSideEffect;
  }
}

export class SendProductOrderEmailSideEffectBuilder extends DataModelBuilder<SendProductOrderEmailSideEffect> {
  build(context: SerializationContext, map: SerializedData): SendProductOrderEmailSideEffect {
    return SendProductOrderEmailSideEffect.fromMap(context, map);
  }
}
